import { Box } from "@mui/material";
import Model from "../base/Model/ui";
import { Row } from "../base/Flex/ui";
import EmailCheckBlocker from "../EmailCheckBlocker/ui";

const EmailUpdateModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <Model.Wrapper open={open} onClose={onClose}>
      <Model.Container size="md">
        <Model.Header.Wrapper>
          <Model.Header.Title></Model.Header.Title>
          <Model.Header.CloseButton close={onClose} />
        </Model.Header.Wrapper>
        <Model.Content>
          <Row type="cc" fullWidth>
            <Box sx={{ padding: "0 16px", height: "100%", width: "100%" }}>
              <EmailCheckBlocker variant="update" onVerified={onClose} />
            </Box>
          </Row>
        </Model.Content>
      </Model.Container>
    </Model.Wrapper>
  );
};

export default EmailUpdateModal;
